import { Card, Stack } from "@mui/material";
import Page from "../Page";
import { FEATURE } from "src/util/enums";
import { useAccess } from "src/hooks/useAccess.hook";
import { useUsers } from "src/hooks/useUsers.hook";
import { BaseTable } from "../BaseTable/BaseTable";
import { userListColumns } from "./user.constants";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { CommonSearchbar } from "src/layouts/dashboard/Searchbar";
import { yearFirstDateTimeFormat } from "src/utils/formatTime";
import { useSelector } from "react-redux";
import ExportCSV from "src/components/ExportCsv/ExportCSV";

export default function UserList() {
  const navigate = useNavigate()
  const { teamId } = useSelector((state) => state.teams);
  const hasCreateAccess = useAccess(FEATURE.USERS, "C");
  const isReadOnly = useAccess(FEATURE.USERS, "R");
  const { data: users, isFetching } = useUsers(teamId);
  const [tableData, setTableData] = useState();
  const rowOrCellClickRedirect = ({ id }) => {
    // if (isReadOnly) return;
    navigate(`/users/${id}`);
  };

  useEffect(() => {
    if (!isFetching) {
      let data = [...users];
      setTableData(data);
    }
  }, [isFetching]);

  const handleSearching = (event) => {
    const dataToSearchFrom = users;
    const searchValue = event.target.value.trim().toString().toLowerCase();
    if (searchValue) {
      const filteredDataArr = dataToSearchFrom.reduce(
        (filteredDataArr, currentObj) => {
          const relevantFields = [
            "username",
            "firstName",
            "lastName",
            "email",
            "createDate",
          ];
          const allValuesArr = Object.entries(currentObj)
            .filter(([key, value]) => relevantFields.includes(key))
            .map(([key, value]) =>
              key === "createDate"
                ? yearFirstDateTimeFormat(value).toString()
                : value ? value.toString().toLowerCase() : ""
            );
          const searchResult = allValuesArr.find((value) =>
            value.includes(searchValue)
          );
          if (searchResult) {
            filteredDataArr = [...filteredDataArr, currentObj];
          }
          return filteredDataArr;
        },
        []
      );
      // console.log(filteredDataArr);
      setTableData(filteredDataArr);
    } else setTableData([...users]);
  };

  return (
    <Page
      title="Users | Smart-CMS"
      actions={
        hasCreateAccess
          ? [{ path: "/users/new", text: "Add CMS System User", icon: "eva:plus-fill" }]
          : []
      }
      hasCreateAccess={hasCreateAccess}
    >
      <Card sx={{ p: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <CommonSearchbar
            placeholder="Search"
            searchFunc={(e) => handleSearching(e)}
          />
          <ExportCSV
            rows={tableData || []}
            columns={userListColumns(isReadOnly)}
            csvMorphemes="cms_system_users"
            csvColumns={userListColumns(isReadOnly)}
          />
        </Stack>
        <BaseTable
          rows={tableData ?? []}
          columns={userListColumns(isReadOnly)}
          loading={isFetching}
          getRowId={(row) => row.userId}
          showExportCsvBtn={false}
          csvMorphemes="cms_system_users"
          rowOrCellClickRedirect={rowOrCellClickRedirect}
          isReadOnly={isReadOnly}
          csvColumns={userListColumns(isReadOnly)}
        />
      </Card>
    </Page>
  );
}
